import React, { useEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { useParams } from "react-router-dom";
import HomeDetailComponent from './HomeDetailComponent';
//import HomeCheckListComponent from './HomeCheckListComponent';
import StaffComponent from './StaffComponent';
import HomeAuditReportManagement from '../AuditReportManagement/HomeAuditReportManagement';
import * as apiUtility from "../../config/APIUtils";
import HomeAdminPermissions from '../AdminPermissions_Component/HomeAdminPermissions';
import TrainingSponsorship from './TrainingSponsorshipComponent';
import HomeCheckListAndPolicyComponent from './HomeCheckListAndPolicyComponent'

function HomeMainComponent(props) {
    const [homes_list, setHomesList] = useState([]);

    const [user_ID, setUser_ID] = useState(-1);

    var propsId = props.homeIdFprAdmin
    var params = propsId;
    if (props.id) {
        params = props.id
    }

    var user_id = useParams().id;
    var propsId2 = props.userId;
    var userID = propsId2;
    if (!userID) {
        userID = user_id;
    }
    
    useEffect(async () => {
        setUser_ID(userID);
        if (props.homeIdFprAdmin) {
            params = props.homeIdFprAdmin
        }
        var orgProps;
        if (props.orgId) {
            orgProps = props.orgId
        }

        if(orgProps == undefined && params !== undefined){
            //When ORG ID is not present just search with Home ID
            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/getHomeDetails/" + params;
            await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                setHomesList(res.data)
            }).catch((error) => {
                console.error(error);
                // setshowSpinner(false);
            });

        }else{
            //When ORG ID is present, then search for all Home.
            const BASE_URL_GET_All_HOMELIST = "orgnization/getHomesList/" + orgProps;
            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_GET_All_HOMELIST;
            await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                setHomesList(res.data)
            }).catch((error) => {
                console.error(error);
            });
        }

        
    }, [props.homeIdFprAdmin])

    

    return (
        <div>

            <Tabs defaultActiveKey="homeDetails" fill style={{ display: "flex", marginTop: "2pc" }}>
                <Tab eventKey="homeDetails" title="Home Details">
                    <HomeDetailComponent homeIdForAdmin={params} />
                </Tab>
                <Tab eventKey="homeStaffComponent" title="Manage Staff">
                    <StaffComponent id={params} />
                </Tab>
                 <Tab eventKey="homeComponent" title="Manage Position Templates">
                    <HomeCheckListAndPolicyComponent id={params} orgId={props.orgId} />
                </Tab>
                <Tab eventKey="homeAuditReport" title="Manage Audit Report">
                    <HomeAuditReportManagement orgFlag={false} userId={user_ID} isChild={props.isChild?true:false} fromUser={props.fromUser?true:false}/>
                </Tab>
                <Tab eventKey="addHomeInHome" title="Manage Home Admin Permission">
                    <HomeAdminPermissions homeID={params} homesList={homes_list} />
                </Tab>
                <Tab eventKey="trainingSponsorship" title="Manage Training Sponsorship">
                    <TrainingSponsorship homeID={params} homesList={homes_list} />
                </Tab>
            </Tabs>

        </div>
    )
}

export default HomeMainComponent